import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import Panel from 'react-bootstrap/lib/Panel'
import Table from 'react-bootstrap/lib/Table'
import acc from 'accounting'

import Loading from 'components/Loading'

import ListSemSubject from './list-sem-subject'
import { fetchCurriculum } from './actions'

const Curriculum = ({ __hasFetched, __item }) => {
  if (!__hasFetched) {
    return <Loading />
  }

  const lec = acc.formatNumber(__item.getIn(['meta', 'total_lec']), 1)
  const lab = acc.formatNumber(__item.getIn(['meta', 'total_lab']), 1)
  const total = acc.formatNumber(__item.getIn(['meta', 'total']), 1)

  return (
    <Panel header="My Curriculum">
      {__item.get('data') && __item.get('data').map((semsubjects, i) => (
        <ListSemSubject key={i} items={semsubjects} />
      ))}
      <Table condensed hover>
        <thead>
          <tr className="active">
            <th width="55%" colSpan="2" className="text-right">Total in Curriculum:</th>
            <th width="6%" className="text-right">{lec}</th>
            <th width="6%" className="text-right">{lab}</th>
            <th width="6%" className="text-right">{total}</th>
            <th width="27%">{' '}</th>
          </tr>
        </thead>
      </Table>
      <hr />
      <div className="row">
        <div className="col-sm-4">
          <h5>Table Legend:</h5>
          <Table condensed>
            <tbody>
              <tr><td className="danger">Failed</td></tr>
              <tr><td className="success">Passed</td></tr>
              <tr><td className="info">Currently Taking</td></tr>
            </tbody>
          </Table>
        </div>
      </div>
    </Panel>
  )
}

Curriculum.onEnter = (store) => () => store.dispatch(fetchCurriculum())

Curriculum.propTypes = {
  __hasFetched: PropTypes.bool,
  __item: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    __hasFetched: state.curriculum.get('hasFetched'),
    __item: state.curriculum.get('item'),
  }
}
export default connect(mapStateToProps)(Curriculum)



// WEBPACK FOOTER //
// ./src/containers/Curriculum/index.js